<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-contract-btn">
  <button mat-fab color="primary" matTooltip="Kreiraj ugovor" (click)="goToCreateContract()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="contracts-container">
  @for (contract of filteredContracts; track contract) {
    <div class="col-lg-4 col-md-6 contract-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ contract.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Klasa:</strong> {{ contract.classification }}</p>
          <p><strong>Urudžbeni broj:</strong> {{ contract.refNumber }}</p>
          @if (projectType === ProjectType.Application) {
            <p><strong>Broj ugovora:</strong> {{ contract.number }}</p>
          }
          @if (projectType === ProjectType.Allocation) {
            <p><strong>Klasa Odluke općinskog načelnika:</strong> {{ contract.decisionClassificationCode }}</p>
            <p><strong>Urudžbeni broj Odluke općinskog načelnika:</strong> {{ contract.decisionReferenceNumber }}</p>
            <p><strong>Datum Odluke općinskog načelnika:</strong> {{ contract.decisionDate }}</p>
          }
          <p><strong>Datum ugovora:</strong> {{ contract.date | date: 'd.M.yyyy.' }}</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Uredi ugovor" (click)="goToEditContract(contract)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Preuzmi ugovor" (click)="downloadContract(contract)">
            <mat-icon>download</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Obriši ugovor" (click)="confirmDelete(contract)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>